<div>
  <p class="attention">ATTENTION!</p>
  <p class="explanation">
    The replacement item is longer by
    {{
      differenceInMS
        | timecode: channelFramerate : (channelFramerate ? "fps" : "ms") : true
    }}
  </p>

  <div class="actions">
    <p class="option" [ngClass]="{ selected: selectedOption === 0 }">
      <input
        id="rdOption1"
        type="radio"
        name="radiogroup"
        checked="checked"
        (change)="selectedOption = 0; strategyChanged.emit(0)"
      />
      <label for="rdOption1">Push forward the rest of the playlist</label>
    </p>
    <p class="option" [ngClass]="{ selected: selectedOption === 1 }">
      <input
        id="rdOption2"
        type="radio"
        name="radiogroup"
        (change)="selectedOption = 1; strategyChanged.emit(1)"
      />
      <label for="rdOption2">Keep current show duration</label>
    </p>
  </div>
</div>
